module.exports = __webpack_public_path__ + "img/icon_zhongjianjian@2x.77747f8c.png";